import { HERO_IMAGE_URL } from "@/pages/home/components/heroImageUrl";

export default function HeroImage() {
  return (
    <>
      {/* Mobile: blurred version of the same image fills the whole screen behind the photo */}
      <div
        className="absolute inset-0 h-full w-full scale-110 bg-cover bg-center blur-2xl brightness-110 md:hidden"
        style={{ backgroundImage: `url('${HERO_IMAGE_URL}')` }}
        aria-hidden="true"
      />
      {/* Main image: whole building visible on mobile (contain, pinned to top), full-bleed on desktop (cover) */}
      <div
        className="absolute inset-0 h-full w-full bg-contain bg-top bg-no-repeat brightness-110 md:bg-cover md:bg-center"
        style={{ backgroundImage: `url('${HERO_IMAGE_URL}')` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/90 via-secondary-950/55 to-transparent" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/60 via-transparent to-secondary-950/20" aria-hidden="true" />
    </>
  );
}